import { useEffect, useState } from 'react';
import './Navbar.css';
import { servicesData } from '../data/servicesData';

const links = [
  { href: '#/', label: 'Home' },
  { href: '#/about', label: 'About' },
  { href: '#/services', label: 'Services' },
  { href: '#/technologies', label: 'Technologies' },
  { href: '#/portfolio', label: 'Portfolio' },
  { href: '#/softwares', label: 'Softwares' },
  { href: '#/videos', label: 'Videos' },
  { href: '#/blog', label: 'Blog' },
  { href: '#/testimonials', label: 'Testimonials' },
  { href: 'https://aerialrootacademy.com/', label: 'Academy', external: true },
  { href: '#/contact', label: 'Contact' },
];

export default function Navbar({ currentRoute = '' }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);

  // Site is permanently light-themed — no dark mode toggle.
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'light');
  }, []);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu when the route changes
  useEffect(() => { setMenuOpen(false); setMobileServicesOpen(false); }, [currentRoute]);

  // Lock body scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const isActive = (href) =>
    href === '#/'
      ? (currentRoute === '' || currentRoute === '#/' || currentRoute === '#/home')
      : href === '#/blog' || href === '#/softwares'
      ? (currentRoute === href || currentRoute.startsWith(href + '/'))
      : currentRoute === href;

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <a href="#/" className="logo">
        <img src="logo.png" alt="AerialRoot Services" />
      </a>

      <button
        type="button"
        className={`nav-toggle ${menuOpen ? 'open' : ''}`}
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(o => !o)}
      >
        <span />
        <span />
        <span />
      </button>

      {menuOpen && <div className="nav-backdrop" onClick={() => setMenuOpen(false)} />}

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {links.map(l => (
          l.href === '#/services' ? (
            <li key={l.href} className={`nav-dropdown ${mobileServicesOpen ? 'mobile-open' : ''}`}>
              <div className="nav-dropdown-row">
                <a href={l.href} className={isActive(l.href) ? 'active' : ''}>{l.label}</a>
                <button
                  type="button"
                  className="nav-dropdown-toggle"
                  aria-label="Toggle services submenu"
                  aria-expanded={mobileServicesOpen}
                  onClick={(e) => { e.preventDefault(); setMobileServicesOpen(o => !o); }}
                >
                  <span>▾</span>
                </button>
              </div>
              <ul className="nav-dropdown-menu">
                {servicesData.map(s => (
                  <li key={s.slug}>
                    <a href={`#/services/${s.slug}`}>{s.title}</a>
                  </li>
                ))}
              </ul>
            </li>
          ) : l.external ? (
            <li key={l.href}>
              <a href={l.href} target="_blank" rel="noopener noreferrer">{l.label}</a>
            </li>
          ) : (
            <li key={l.href}>
              <a href={l.href} className={isActive(l.href) ? 'active' : ''}>{l.label}</a>
            </li>
          )
        ))}
      </ul>
    </nav>
  );
}
